import './Teacher.style.scss'
import { FiUsers } from 'react-icons/fi'
import Header from '../../component/header/header'
import Pagination from '../../component/pagination/pagination'
import { useCallback, useEffect, useState } from 'react'
import { TeacherProps } from './TeacherInterface'
import { TeacherCard } from './TeacherCard'
import { limitPagination, LoaderComponent } from '../../utils/Helper'
import { listTeacher, deleteTeacherData } from '../../api/teacher'
import { useNavigate } from 'react-router-dom'
import { successMessage, errorMessageShow } from '../../utils/Helper'

const Teacher: React.FC = () => {
  const [teacherData, setTeacherData] = useState<TeacherProps[]>([])
  const [totalPage, setTotalPage] = useState<number>(1)
  const [error, setError] = useState<string | null>(null)
  const [page, setPage] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(true)
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null)
  const [searchKey, setSearchKey] = useState<string>('')
  const navigate = useNavigate()
  const [seachBtnClick, setSearchBtnClick] = useState<number>(0)

  useEffect(() => {
    const delayDebounceFn = setTimeout(
      () => {
        fetchTeacherData(searchKey)
      },
      seachBtnClick === 0 ? 500 : 0
    )

    return () => clearTimeout(delayDebounceFn)
  }, [searchKey, page, seachBtnClick])

  const fetchTeacherData = useCallback(
    async (search = '') => {
      try {
        setLoading(true)
        const response = await listTeacher(search ? 1 : page, search)
        const teachers = response?.data?.data?.teachers || []
        const total = response?.data?.data?.total_records || 1
        if (!teachers.length) {
          errorMessageShow('Oops! No teacher found.')
        }
        const formattedData = teachers.map((teacher: any) => ({
          id: teacher.id,
          first_name: teacher.first_name || '',
          last_name: teacher.last_name || '',
          address: teacher.address || '',
          phone_number: teacher.phone_number || '',
          email: teacher.email || '',
          profile_photo: teacher.profile_photo || '',
        }))
        if (search) {
          setPage(1)
        }
        setTeacherData(formattedData)
        setTotalPage(total)
        setError(null)
      } catch (err) {
        console.error('Failed to fetch teacher data:', err)
        setError('Failed to load teacher data.')
      } finally {
        setLoading(false)
      }
    },
    [page]
  )

  const deleteTeacher = async (teacherId: string | number) => {
    try {
      const delTeacher = await deleteTeacherData(teacherId)
      if (delTeacher) {
        setTeacherData((prevTeachers) =>
          prevTeachers.filter((teacher) => teacher.id !== teacherId)
        )
        successMessage('Teacher deleted successfully!')
      }
    } catch (error) {}
  }

  const handleTeacherUpdate = (updatedTeacher: TeacherProps) => {
    const teacherId = updatedTeacher?.data?.id
    if (teacherId) {
      const updateData = updatedTeacher?.data
      setTeacherData((prevData) => {
        return prevData.map((teacher) => {
          if (teacher.id === teacherId) {
            return { ...teacher, ...updateData }
          }
          return teacher
        })
      })
    }
  }

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKey(e.target.value)
  }

  const onSearchButtonClick = () => {
    if (searchKey) {
      setSearchBtnClick((prev) => prev + 1)
      setPage(1)
    }
  }

  return (
    <div className='content teachers_page'>
      <Header
        pageTitle={`Teachers`}
        // pageTitle={`Teachers ${totalPage > 0 ? `(${totalPage}/ ${teacherData.length})` : ""}`}
        buttonText='Add Teacher'
        buttonIcon={<FiUsers fontSize={20} />}
        path='/teachers/create'
        isHeader={true}
        searchPlaceholder='Search by name'
        onSearchChange={onSearchChange}
        search={searchKey}
        onClick={() => navigate('/teachers/create')}
        onSearchClick={onSearchButtonClick}
      />

      {loading && teacherData.length === 0 ? (
        <LoaderComponent fillPage label="Loading teachers…" />
      ) : (
        <div className='teachers_page_container'>
          {teacherData.length > 0 ? (
            teacherData.map((item, index) => {
              return (
                <TeacherCard
                  key={`${item.id}`}
                  item={item}
                  index={index}
                  openMenuIndex={openMenuIndex}
                  setOpenMenuIndex={setOpenMenuIndex}
                  deleteTeacher={deleteTeacher}
                  onTeacherUpdate={handleTeacherUpdate}
                  teachers={teacherData}
                />
              )
            })
          ) : error ? (
            <p className='error_message'>{error}</p>
          ) : (
            <p>No teachers available</p>
          )}
        </div>
      )}

      {!loading || teacherData.length > 0 ? (
        <Pagination
          postsPerPage={limitPagination}
          length={totalPage}
          currentPage={page}
          handlePagination={(newPage: number) => setPage(newPage)}
        />
      ) : null}
    </div>
  )
}
export default Teacher
